import { DecimalPipe } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';

import { RdsNumberFormat } from '../models';

@Pipe({
  name: 'rdsNumber',
})
export class RdsNumberPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {}

  transform(value: null | undefined | number, ...args: Array<string | number>): string {
    if (value === null || value === undefined) {
      return '';
    }
    const minFractionDigits: string | number = args[0] !== null && args[0] !== undefined ? args[0] : '0';
    const maxFractionDigits: string | number = args[1] !== null && args[1] !== undefined ? args[1] : '2';
    const format: RdsNumberFormat = (args[2] || 'NONE') as RdsNumberFormat;
    const transformedValue: string = this.decimalPipe.transform(value, `1.${minFractionDigits}-${maxFractionDigits}`) || '';
    switch (format) {
      case 'PERCENT':
        return `${transformedValue}%`;
      default:
        return transformedValue;
    }
  }
}

@NgModule({
  exports: [RdsNumberPipe],
  declarations: [RdsNumberPipe],
  providers: [DecimalPipe],
})
export class RdsNumberPipeModule {}
